export const redirectUnauthorized = (navigate) => {
  return navigate(0, { replace: true });
};
